

















import { defineComponent } from '@vue/composition-api';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { Size } from '@front-app/components/constants';

export default defineComponent({
	components: { CtaButton, SimpleCard },
	setup() {
		return {
			Size,
			ButtonPalettes,
		};
	},
});
